module.exports = __webpack_public_path__ + "img/purple-push.7fa7382c.jpeg";